export default class Product {
  constructor (data = {}) {
    Object.keys(data).map(key => {
      this[key] = data[key];
    });
  }
  static fromJson (json) {
    return new Product(json);
  }
}
